import { render, staticRenderFns } from "./Skeleton.vue?vue&type=template&id=31c72680&scoped=true&"
import script from "./Skeleton.vue?vue&type=script&lang=js&"
export * from "./Skeleton.vue?vue&type=script&lang=js&"
import style0 from "./Skeleton.vue?vue&type=style&index=0&id=31c72680&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c72680",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31c72680')) {
      api.createRecord('31c72680', component.options)
    } else {
      api.reload('31c72680', component.options)
    }
    module.hot.accept("./Skeleton.vue?vue&type=template&id=31c72680&scoped=true&", function () {
      api.rerender('31c72680', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Orders/components/Skeleton.vue"
export default component.exports